import { SplideSlide } from '@splidejs/react-splide'
import { arrayOf, node, oneOfType } from 'prop-types'

const SplideJsSlide = ({ slide }) => {
  return (
    <SplideSlide>
      {slide}
    </SplideSlide>
  )
}

SplideJsSlide.propTypes = {
  slide: oneOfType([node, arrayOf(node)])
}

export default SplideJsSlide
